/* MQA: auto-fit the mobile wordmark. Measures the actual space its box allows (which already accounts
   for the header icons) and sizes the text to fill it exactly — capped at a sensible max, floored so it
   stays legible, and re-fit on resize/rotate/font-load. No hardcoded width math, so it can't fall out
   of sync when the name, the icons, or the viewport change. */
(function () {
  var MAX = 26;   // never larger than this on mobile
  var MIN = 11;   // never smaller than this (readable floor)

  function fit() {
    var el = document.querySelector('.header__row-mobile .header__logo-text');
    if (!el || !el.offsetParent) return;            // mobile header not visible → nothing to do

    var cap = MAX;
    var themeMax = parseFloat(getComputedStyle(el).getPropertyValue('--logo-font-size'));
    if (themeMax) cap = Math.min(cap, themeMax);

    el.style.fontSize = cap + 'px';                 // measure at the cap
    var box = el.clientWidth;                        // width the box allows (max-width/track already applied)
    var text = el.scrollWidth;                       // width the text needs at the cap
    if (box > 0 && text > box) {
      var size = cap * box / text - 0.4;             // scale down to fit, tiny safety margin
      el.style.fontSize = Math.max(MIN, size).toFixed(2) + 'px';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit);
  else fit();
  window.addEventListener('resize', fit);
  window.addEventListener('orientationchange', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  [150, 500, 1200].forEach(function (t) { setTimeout(fit, t); }); // catch late layout/font settling
})();
